module.exports = __webpack_public_path__ + "img/k5.13e663c9.png";